import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Zap, Flame, Gift } from 'lucide-react';
export function Pricing() {
  return <section id="oferta" className="py-24 relative overflow-hidden" data-id="element-178">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-[500px] bg-[#2F80ED]/20 blur-[150px] rounded-full pointer-events-none" data-id="element-179" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-181">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-4" data-id="element-182">
            Oferta especial
          </h2>

          {/* Urgency alert */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-bold mt-4" data-id="element-183">
            <Flame className="w-4 h-4 animate-pulse" data-id="element-184" />
            <span data-id="element-185">90% YA VENDIDO — Se están agotando los últimos manuales</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-xl mx-auto" data-id="element-186">
          <div className="relative rounded-3xl p-[1px] bg-gradient-to-b from-[#2F80ED] to-[#2F80ED]/10 blue-glow-strong" data-id="element-187">
            <div className="bg-[#0D1117] rounded-[23px] p-8 md:p-12 h-full" data-id="element-188">
              {/* Stock Bar */}
              <div className="mb-8" data-id="element-189">
                <div className="flex justify-between items-center text-xs font-bold mb-2" data-id="element-190">
                  <span className="text-red-400" data-id="element-191">UNIDADES VENDIDAS</span>
                  <span className="text-red-400" data-id="element-192">90%</span>
                </div>
                <div className="w-full h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-193">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '90%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.4,
                  ease: 'easeOut'
                }} className="h-full bg-gradient-to-r from-amber-500 to-red-500 rounded-full shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-194" />
                </div>
                <p className="text-xs text-gray-500 mt-2" data-id="element-195">
                  Solo queda un 10% del stock disponible
                </p>
              </div>

              {/* Value Stack */}
              <div className="space-y-3 mb-6 pb-6 border-b border-white/10" data-id="element-196">
                <div className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-4" data-id="element-197">
                  Valor individual:
                </div>
                <div className="flex justify-between items-center text-gray-300" data-id="element-198">
                  <span data-id="element-199">Nivel 1</span>
                  <span className="font-mono" data-id="element-200">$19.900</span>
                </div>
                <div className="flex justify-between items-center text-gray-300" data-id="element-201">
                  <span data-id="element-202">Nivel 2</span>
                  <span className="font-mono" data-id="element-203">$19.900</span>
                </div>
                <div className="flex justify-between items-center text-gray-300" data-id="element-204">
                  <span data-id="element-205">Nivel 3</span>
                  <span className="font-mono" data-id="element-206">$19.900</span>
                </div>
                <div className="flex justify-between items-center text-[#2F80ED] font-medium" data-id="element-207">
                  <span data-id="element-208">Bonus Exclusivos</span>
                  <span className="font-mono" data-id="element-209">$24.900</span>
                </div>
                <div className="flex justify-between items-center pt-4 mt-4 border-t border-white/5" data-id="element-210">
                  <span className="text-gray-400 font-semibold" data-id="element-211">
                    Valor real total:
                  </span>
                  <span className="text-gray-500 line-through font-mono text-xl" data-id="element-212">
                    $84.600
                  </span>
                </div>
              </div>

              {/* Bonification notice */}
              <div className="flex items-start gap-3 mb-6 p-4 rounded-xl bg-emerald-500/5 border border-emerald-500/20" data-id="element-213">
                <Gift className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-214" />
                <p className="text-emerald-300 text-sm leading-relaxed" data-id="element-215">
                  <strong className="text-emerald-400" data-id="element-216">
                    Todos los libros están bonificados
                  </strong>{' '}
                  comprando el primero. Pagás solo uno, te llevás los 3 + bonus.
                </p>
              </div>

              {/* Offer */}
              <div className="text-center mb-8" data-id="element-217">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-sm font-bold mb-6" data-id="element-218">
                  <Zap className="w-4 h-4" data-id="element-219" />
                  HOY ACCESO COMPLETO
                </div>
                <div className="text-sm text-gray-500 uppercase tracking-wider font-bold mb-1" data-id="element-220">
                  Hoy pagás solo
                </div>
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-221">
                  <span className="text-3xl font-bold text-gray-400" data-id="element-222">$</span>
                  <span className="text-6xl md:text-7xl font-bold font-heading text-white" data-id="element-223">
                    19.900
                  </span>
                </div>
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-xs font-bold mt-2 mb-3" data-id="element-224">
                  AHORRÁS $64.700
                </div>
                <p className="text-gray-400 text-sm" data-id="element-225">
                  Pago único. Acceso de por vida.
                </p>
              </div>

              <a href="https://checkout.librofy.online/cart/53265711235435:1" target="_blank" rel="noopener noreferrer" className="w-full bg-[#2F80ED] hover:bg-[#2563EB] text-white py-5 rounded-2xl font-bold text-xl transition-all flex items-center justify-center gap-3 blue-glow hover:scale-[1.02] mb-6" data-id="element-226">
                QUIERO ACCEDER AHORA
              </a>

              <div className="flex items-center justify-center gap-2 text-amber-400 text-sm font-medium" data-id="element-227">
                <Clock className="w-4 h-4" data-id="element-228" />
                <span data-id="element-229">Oferta por tiempo limitado</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}